import { gsap } from 'gsap';
import { scrollToYPos } from '../helpers/scrollHelpers';
import runTextAnimations from '../animations/textAnimations';

const triggers = document.querySelectorAll('.js-change-screen');
triggers.forEach((el) => {
	el.addEventListener('click', (e) => {
		e.preventDefault();

		newScreen = el.getAttribute('data-screen-to');
		if (!newScreen) return;
		changeScreen(newScreen);

		const currScreen = getCurrentScreen(el);
		updateBackButtons(currScreen);
	});
});

function changeScreen(newScreenId = false, currScreen = false) {
	if (!newScreenId) {
		console.error('changeScreen must include the newScreen parameter');
		return;
	}

	const newScreen = document.querySelector(`.js-screen[data-screen="${newScreenId}"]`);
	if (newScreen) {
		// Set body height to current height before transition
		setContentWrapperHeight();

		const duration = 0.5;
		const ease = 'power4.easeInOut';
		const yDiff = 30;

		// Fade out active screen
		const tl = gsap.timeline();

		const screens = gsap.utils.toArray('.js-screen.is-active');
		tl.to(screens, {
			y: yDiff,
			opacity: 0,
			display: 'none',
			duration,
			ease,
			onComplete: () => {
				scrollToYPos(0, duration + 0.2);
				setTimeout(() => {
					runTextAnimations(newScreenId);
				}, duration * 1000 - 200);
			},
		});

		tl.fromTo(
			newScreen,
			{
				y: yDiff,
				opacity: 0,
				display: 'none',
				duration,
				ease,
			},
			{
				y: 0,
				opacity: 1,
				display: 'block',
				onComplete: () => {
					newScreen.classList.add('is-active');
					unsetContentWrapperHeight();
					// showAgeGate();
				},
			},
			duration + 0.2
		);
	}
}

function setContentWrapperHeight() {
	const contentWrapper = document.querySelector('.content-wrapper');
	contentWrapper.style.height = contentWrapper.offsetHeight + 'px';
}

function unsetContentWrapperHeight() {
	document.querySelector('.content-wrapper').style.height = 'auto';
}

function updateBackButtons(currScreen) {
	if (!currScreen) {
		console.error('No current screen passed to updateBackButtons function');
		return;
	}

	const buttons = document.querySelectorAll('.js-back-screen');
	buttons.forEach((button) => {
		button.setAttribute('data-screen-to', currScreen.getAttribute('data-screen'));
	});
}

function getCurrentScreen(el) {
	if (!el) return false;

	return el.closest('.js-screen') ?? false;
}

export { changeScreen };
